/** The way in, beside Help & Insights: Sam's face and his name. One tap from
 *  any screen. Hidden when the person has no tick, and hidden while the demo
 *  switch is on.
 *
 *  The panel itself is NOT here: it lives in the dock above the routes
 *  (components/helper/HelperDock), so a page change cannot close it or clear
 *  the conversation. This button only opens it.
 */
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import api from '../../lib/api';
import { useHelperDock } from '../../lib/HelperDockContext';
import SamCharacter from './SamCharacter';

export const HelperLauncher = ({ variant = 'dark' }) => {
    const { t } = useTranslation();
    const dock = useHelperDock();
    const [name, setName] = useState('Sam');
    const [picture, setPicture] = useState('sam');

    useEffect(() => {
        if (!dock.allowed) return;
        api.get('/helper/config')
            .then((res) => {
                setName(res.data.sam_name || 'Sam');
                setPicture(res.data.sam_picture || 'sam');
            })
            .catch(() => { /* the pill simply reads Sam */ });
    }, [dock.allowed]);

    // While the panel is pinned or slimmed it is already on screen, so the
    // entry would be a second way in to the same thing.
    if (!dock.allowed || dock.mode === 'pinned' || dock.mode === 'slim') return null;

    return (
        <>
            {/* lg and up: the pill beside Help & Insights. */}
            <button type="button" onClick={dock.open}
                    data-testid="helper-launcher" title={name}
                    className={`hidden lg:inline-flex items-center gap-1.5 insight-toggle ${variant === 'light' ? 'insight-toggle--light' : ''}`.trim()}>
                {picture !== 'none' && (
                    <SamCharacter mood="happy" size="slim" name={name} className="w-5 h-5" />
                )}
                <span>{name}</span>
            </button>
            {/* Phone: the portal's own top bar owns that row, so the way in is a
                small round button in the corner, clear of the page content. */}
            <button type="button" onClick={dock.open}
                    data-testid="helper-launcher-mobile"
                    aria-label={name} title={name}
                    className="lg:hidden fixed bottom-4 right-4 z-40 w-14 h-14 rounded-full bg-slate-900 text-white shadow-lg grid place-items-center active:scale-95 transition-transform">
                {picture !== 'none'
                    ? <SamCharacter mood="happy" size="slim" name={name} className="w-11 h-11" />
                    : <span className="text-xs font-semibold">{t('helper.title')}</span>}
            </button>
        </>
    );
};

export default HelperLauncher;
